import React, { useState, useEffect } from "react";
import Axios from "./../../utils/api/axiosConf";
import { url } from "../../utils/api/api";
import TABLE from "../../components/table/table";
import { RedNotif, GreenNotif, FarsiDate } from "../../utils/utils";
import { Row, Col, Modal } from "antd";
import { color } from "../../utils/themes/color";
import TABALE from "./../../components/table/table";


export default function Transactions() {

    const [loading, setLoading] = useState({ 1: false, 2: false })
    const [data, setData] = useState([]);
    const [page, setPage] = useState({ current: 1, total: 1, pageSize: 5 })
    const [updater, setUpdater] = useState(1);
    const [transactions, setTransactions] = useState({ fullName: "", description: "", amount: "", days: "", insertDate: "", mode: "", type: "" });


    useEffect(() => {
        setLoading({ ...loading, 1: true })
        Axios.get(`${url}transactions/get-transactions?limit=${page.pageSize}&pageNumber=${page.current}`)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {

                    setLoading({ ...loading, 1: false })
                    setData(response.data.docs)
                    setPage({
                        ...page,
                        current: response.data.page,
                        total: response.data.totalDocs

                    })
                }
                else {
                    RedNotif(response.message)
                }
            })
            .catch((error) => {
                RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
            });
    }, [page.current, updater])

    const columns = [
        {
            title: 'نام کاربر',
            dataIndex: 'user',
            render: (user) => user != undefined ?
                    <p> {user.fullName} </p>
                    : <p></p> ,
            key: '_id',
        },
        {
            title: 'توضیحات',
            dataIndex: 'description',

        },
        {
            title: 'مقدار',
            dataIndex: 'amount',

        },
        {
            title: 'روزها',
            dataIndex: 'days',

        },
        {
            title: 'تاریخ',
            dataIndex: 'insertDate',
            render: (insertDate) => <p>{FarsiDate(insertDate)}</p>,

        },
        {
            title: 'حالت',
            dataIndex: 'mode',
            render: (mode) => <p>{Mode(mode)}</p>,
            key: '_id',

        },
        {
            title: 'نوع تراکنش',
            dataIndex: 'type',
            render: (type) => <p>{Type(type)}</p>,
            key: '_id',

        },



    ];

    const Mode = (R) => {
        switch (R) {
            case "additive": return "افزایشی"
            case "decrease": return "کاهشی"
        }
    }

    const Type = (R) => {
        switch (R) {
            case "subscription": return "اشتراک"
            case "order": return "کیف پول"
        }
    }


    const pager = (p) => {
        if (p != undefined) {
            setPage({ ...page, current: p })
        }
        return page;
    }


    return (
        <>

            <Row >
                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                    <div style={{ background: color.onPrimary, width: '100%', height: "40px", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <p style={{ color: "white", fontSize: "18px" }}>لیست تراکنش ها</p>
                    </div>
                    <TABALE
                        data={data}
                        columns={columns}
                        page={pager}
                        loading={loading[1]}
                    />
                </Col>

            </Row>
        </>
    )
} 